import React from 'react';
import { getNameInitials } from '../../../../shared/services/Utility';
import noDataIcon from '../../../../Assets/Images/Icons/no_data.png';
import './style.scss';

const LeaderboardListView = ({
  data = [],
  send_or_recieve,
  challengeSentTo,
  userName,
  // type = "company",
}) => {
  // data.length &&
  //   data.sort((a, b) =>
  //     a.highestScore.toLowerCase().localeCompare(b.highestScore.toLowerCase())
  //   );
  return data.length ? (
    data.length === 1 && data[0].userName === userName ? (
      <div className='no-data-found'>
        <img src={noDataIcon} alt='' height={30} width={30}/>
        <p style={{ margin: 20 }}>No Data Yet !</p>
      </div>
    ) : (
      <div className='card_hist'>
        <ul>
          {data.map((itm, index) => {
            return (
              <li key={index}>
                <div className='d-flex align-items-center card_history list-wrapper'>
                  <div className='name-container'>
                    <span>
                      {itm.userName &&
                        itm.userName !== '' &&
                        itm.userName.length > 0 &&
                        getNameInitials(itm.userName).toUpperCase()}
                    </span>
                    <h6 style={{ color: '#807373', fontWeight: '400' }}>
                      {itm.userName}
                    </h6>
                  </div>
                  {/* {type === "company" ? ( */}
                  {/* <p>
                      <button
                        className="green-btn"
                        type="button"
                        onClick={() => challengeSentTo(itm.userId)}
                      >
                        Challenge
                      </button>
                    </p> */}
                  {/* ) : ( */}
                  <div className='scoreContainer'>
                    <div className='starIconWrapper'/>
                    <p>{itm.highestScore}%</p>
                  </div>
                  {/* )} */}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    )
  ) : (
    <div className='no-data-found'>
      <img src={noDataIcon} alt=''/>
      <p>No Data Yet !</p>
    </div>
  );
};

export default LeaderboardListView;
